module.exports = __webpack_public_path__ + "img/icon_AUTO.177b93c5.svg";